import React, { useState } from "react";
import axios from "axios";
import "./uploadusers.css";

const UploadUsers = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post("/api/uploadusers", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(response.data.message || "File uploaded successfully.");
    } catch (error) {
      setMessage("Error uploading file. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="upload-users-container">
      <div className="upload-box">
        <h5>Upload User Data</h5>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          className="file-input"
        />
        <button onClick={handleUpload} className="upload-btn">
          Upload CSV
        </button>
        {message && <p className="upload-message">{message}</p>}
      </div>
    </div>
  );
};

export default UploadUsers;
